// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import UserDetails from "../../components/dashboard/UserDetails";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <UserDetails />
    </DashboardLayout>
  );
}
